var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "viewer", attrs: { id: "cesiumContainer" } }, [
    _c("div", { staticClass: "sm-panel", attrs: { id: "viewer-panel" } }, [
      _c("div", { staticClass: "sm-content" }, [_vm._t("default")], 2)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }